import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../../shared/context/auth-context";
import "../List.scss";

//mui - manter os componentes da tabela
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
//lucide-react para ícones
import {
  Trash2,
  ClipboardCheck,
  Eye,
  Undo,
  DollarSign,
  History,
} from "lucide-react";
//date-fns para substituir moment
import { format } from "date-fns";
//Antd
import { Popover } from "antd";
import { Popconfirm } from "antd";

import { abreviarNome } from "../../../../../../shared/util/helperFunctions";
import {
  podeAlterarRegisto,
  motivoBloqueioUnidade,
} from "../../../../../../shared/util/unidadeRegisto";
import BadgeUnidade from "../../../../../../shared/components/badgeUnidade/BadgeUnidade";

/* Autoria da importação. O `criadoPor` estava gravado desde o início mas só se
   via em base de dados — na lista havia o sinal de "isto veio do papel" e mais
   nada. Quem audita precisa das duas coisas: quem copiou a ficha e quando. */
const legendaImportado = (row) => {
  const base = "Histórico importado — tratamento feito antes de usar o sistema";
  const quem = row.criadoPor?.name ? abreviarNome(row.criadoPor.name) : null;
  const quando = row.created_at
    ? format(new Date(row.created_at), "dd/MM/yyyy")
    : null;

  if (!quem && !quando) return base;

  const autoria = [quem && `por ${quem}`, quando && `a ${quando}`]
    .filter(Boolean)
    .join(" ");

  return `${base}. Importado ${autoria}`;
};

function ListTratamentoIsolados({
  data,
  handleOpenModal,
  handleEliminar,
  handleCancelarExecucao,
  handleLancarDebito,
}) {
  const [tratamentoIsolados, setTratamentoIsolados] = useState(data);
  const auth = useContext(AuthContext);
  useEffect(() => {
    setTratamentoIsolados(data);
  }, [data]);

  const getMenuContent = (row) => {
    const menuItems = [];
    let hasContent = false;

    /* Tratamento isolado de outra unidade: só de leitura.
     *
     * As três opções deste menu — eliminar, cancelar execução e lançar débito —
     * são todas mutações, e as duas últimas mexem em dinheiro. Ver continua a
     * fazer-se pelo ícone da linha. */
    if (!podeAlterarRegisto(row.estabelecimento, auth)) return "vazio";

    if (
      !row.atendido &&
      !row.faltou &&
      auth.perm.includes("d-consult") &&
      (((auth.role === "Médico/Administrador" || auth.role === "Dentista") &&
        row.medico._id === auth.userId) ||
        (auth.role === "Secretária(o)" &&
          auth.usuariosAssociados.filter((uA) => uA.id === row.medico._id)
            .length > 0))
    ) {
      hasContent = true;
      menuItems.push(
        <Popconfirm
          key="eliminar"
          title="Desativação de tratamento!"
          description="Tem a certeza que pretende desativar o tratamento?"
          icon={<Trash2 style={{ color: "red" }} />}
          okText="Sim"
          cancelText="Não"
          onConfirm={() => handleEliminar(row._id)}
        >
          <div className="popOverMenu--option">
            <span>Eliminar</span>
            <Trash2 className="popOverMenu--option__icon" />
          </div>
        </Popconfirm>
      );
    }

    if (
      row.atendido &&
      !row.faltou &&
      (auth.role === "Médico/Administrador" || auth.role === "Dentista") &&
      row.medico._id === auth.userId &&
      auth.perm.includes("d-consult")
    ) {
      hasContent = true;
      const naoExec = row.atendimentoNaoExecutado;
      menuItems.push(
        <Popconfirm
          key="cancelar-execucao"
          title={
            naoExec
              ? "Cancelar não execução!"
              : "Cancelamento de execução de tratamento!"
          }
          description={
            naoExec
              ? "Tem a certeza que pretende cancelar a marcação de não execução?"
              : "Tem a certeza que pretende cancelar a execução do tratamento?"
          }
          icon={<Undo style={{ color: "red" }} />}
          okText="Sim"
          cancelText="Não"
          onConfirm={() => handleCancelarExecucao(row._id)}
        >
          <div className="popOverMenu--option">
            <span>{naoExec ? "Cancelar Não Execução" : "Cancelar Execução"}</span>
            <Undo className="popOverMenu--option__icon" />
          </div>
        </Popconfirm>
      );
    }

    // Lançar débito
    if (!row.entrada && row.tratamento && auth.perm.includes("c-ent")) {
      hasContent = true;
      menuItems.push(
        <Popconfirm
          key="debit"
          title="Lançar o valor do tratamento em débito?"
          description="Tem a certeza que pretende lançar o valor do tratamento em débito?"
          icon={<DollarSign style={{ color: "red" }} />}
          okText="Sim"
          cancelText="Não"
          onConfirm={() => handleLancarDebito(row._id)}
        >
          <div className="popOverMenu--option">
            <span>Lançar débito</span>
            <DollarSign className="popOverMenu--option__icon" />
          </div>
        </Popconfirm>
      );
    }

    return hasContent ? (
      <div className="dots__menu__popup">{menuItems}</div>
    ) : (
      "vazio"
    );
  };

  return (
    <>
      <TableContainer component={Paper} className="table">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead style={{ background: "#fff" }}>
            <TableRow>
              <TableCell className="tableCell tableCell--heading tableCell--heading--start">
                Número
              </TableCell>

              <TableCell className="tableCell tableCell--heading tableCell--heading--start">
                Nome
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Médico Responsável
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Data Criação
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Data Inicio
              </TableCell>
              <TableCell className="tableCell tableCell--heading">
                Data Fim
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Estado
              </TableCell>

              <TableCell className="tableCell tableCell--heading tableCell--heading--end">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>

          {tratamentoIsolados && (
            <TableBody>
              {tratamentoIsolados.map((row) => {
                const menuContent = getMenuContent(row);

                return (
                  <TableRow key={row._id}>
                    <TableCell className="tableCell">
                      {row.numero}
                      {/* Histórico em papel: um ícone pequeno e cinzento, não
                          uma pastilha. Quem lê a lista precisa de distinguir o
                          que foi feito NO sistema do que foi copiado de uma
                          ficha antiga — mas isso não deve competir com o
                          estado do tratamento, que é o que se procura aqui. */}
                      {row.historicoImportado && (
                        <Tooltip title={legendaImportado(row)}>
                          <History
                            size={13}
                            style={{
                              marginLeft: 6,
                              color: "#9aa5b1",
                              verticalAlign: "middle",
                            }}
                          />
                        </Tooltip>
                      )}
                      {/* Sem selo de "só consulta": a execução clínica é livre
                          entre unidades. A pastilha diz onde foi marcado. */}
                      <BadgeUnidade estabelecimento={row.estabelecimento} />
                    </TableCell>

                    <TableCell className="tableCell">
                      {row.tratamento?.designacao
                        ? row.tratamento?.designacao
                        : row.categoriaTratamento?.categoria}
                    </TableCell>

                    <TableCell className="tableCell">
                      {abreviarNome(row.medico.name)}
                    </TableCell>

                    <TableCell className="tableCell">
                      {format(new Date(row.created_at), "dd/MM/yyyy")}
                    </TableCell>

                    <TableCell className="tableCell">
                      {row.data_inicio_execucao ? row.data_inicio_execucao : ""}
                    </TableCell>

                    <TableCell className="tableCell">
                      {row.data_fim_execucao ? row.data_fim_execucao : ""}
                    </TableCell>

                    <TableCell className="tableCell">
                      <span
                        className={
                          row.status
                            ? "status " + row.status
                            : row.atendido && !row.atendimentoNaoExecutado
                            ? "status concluido"
                            : row.atendimentoNaoExecutado
                            ? "status naoexecutado"
                            : row.faltou
                            ? "status INTERROMPIDO"
                            : "status pendente"
                        }
                      >
                        {row.atendido && !row.atendimentoNaoExecutado
                          ? "Executado"
                          : row.atendimentoNaoExecutado
                          ? "Não Executado"
                          : row.faltou
                          ? "Faltou"
                          : "Pendente"}
                      </span>
                    </TableCell>
                    <TableCell className="tableCell">
                      <div className="tableCell__action">
                        {/* Executa-se daqui qualquer isolado, com marcação ou
                            sem ela.

                            Durante algum tempo os AGENDADOS estavam travados
                            aqui, e a razão era um defeito e não uma regra: o
                            cancelamento da execução guardava a data sem as
                            horas, o modal relia-a como meia-noite e a execução
                            seguinte movia a marcação para lá — fora da grelha
                            da agenda, que começa às 8h. Corrigida a data, o
                            motivo do bloqueio desapareceu com ele.

                            Fica só a restrição de UNIDADE, que é outra coisa: o
                            modal carrega o catálogo de tratamentos da unidade
                            da SESSÃO, e um tratamento da outra não está lá. */}
                        {(() => {
                          /* ─── PORQUE NÃO BASTA ESCONDER O BOTÃO ───────────
                           *
                           * Quando a unidade não bate certo, o ícone fica
                           * visível e DESATIVADO, a dizer porquê. Antes
                           * desaparecia — e um botão que desaparece sem
                           * explicação lê-se como avaria, não como regra. */
                          const souMedico =
                            auth.role === "Médico/Administrador" ||
                            auth.role === "Dentista";

                          /* Já executado ou faltou: não se explica nada — a
                           * coluna de estado ao lado já o diz. */
                          if (!souMedico || row.atendido || row.faltou)
                            return null;

                          const daUnidade = podeAlterarRegisto(
                            row.estabelecimento,
                            auth
                          );

                          let motivo = null;
                          if (!daUnidade) {
                            motivo = motivoBloqueioUnidade(
                              row.estabelecimento,
                              "executar"
                            );
                          }

                          if (motivo) {
                            return (
                              <Tooltip title={motivo}>
                                <ClipboardCheck
                                  className="icon__list icon__list--desativado"
                                  aria-disabled="true"
                                />
                              </Tooltip>
                            );
                          }

                          return (
                            <Tooltip title="Executar">
                              <ClipboardCheck
                                className="icon__list"
                                onClick={handleOpenModal.bind(
                                  null,
                                  "executar",
                                  row._id
                                )}
                              />
                            </Tooltip>
                          );
                        })()}

                        {auth.perm.includes("r-consult") && !row.faltou && (
                          <Tooltip title="Ver Tratamento Isolado">
                            <Eye
                              className="icon__list"
                              onClick={handleOpenModal.bind(
                                null,
                                "ver",
                                row._id
                              )}
                            />
                          </Tooltip>
                        )}

                        {row.entrada && (
                          <Tooltip
                            title={
                              row.entrada.entradaRecebida
                                ? "Tratamento Recebido"
                                : "Débito Lançado"
                            }
                          >
                            <DollarSign
                              className="icon__list"
                              style={{
                                color: row.entrada.entradaRecebida
                                  ? "12d453"
                                  : "#fdcb7f",
                                cursor: "default",
                              }}
                            />
                          </Tooltip>
                        )}

                        {menuContent !== "vazio" && (
                          <Popover
                            content={menuContent}
                            trigger="click"
                            placement="bottom"
                          >
                            <div className="dots__menu">
                              <div className="dot"></div>
                              <div className="dot"></div>
                              <div className="dot"></div>
                            </div>
                          </Popover>
                        )}
                        {menuContent === "vazio" && (
                          <div>&#12644;&#12644;&#12644;</div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </>
  );
}

export default ListTratamentoIsolados;
